export default __webpack_public_path__ + "static/media/11-control weight.835c6543.svg";